"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateActivityImageRequest = void 0;
var UpdateActivityImageRequest = /** @class */ (function () {
    function UpdateActivityImageRequest() {
    }
    return UpdateActivityImageRequest;
}());
exports.UpdateActivityImageRequest = UpdateActivityImageRequest;
//# sourceMappingURL=updateActivityImage.request.js.map